

export const actionTypes = {
  EXPAND_NAVBAR: 'expand-navbar',
  COLLAPSE_NAVBAR: 'collapse-navbar',
  SET_NAV_FROM_KEY: 'layout.set-nav-from-key',  // Set keystroke information from side nav bar
  UNSET_NAV_FROM_KEY: 'layout.unset-nav-from-key',  // Unset keystroke information from side nav bar
  SET_TAB_FROM_KEY: 'layout.set-tab-from-key',  // Set keystroke information from dashboard tab set
  UNSET_TAB_FROM_KEY: 'layout.unset-tab-from-key',  // Unset keystroke information from dashboard tab set
};

export function expandNavBar() {
  return {
    type: actionTypes.EXPAND_NAVBAR
  }
}

export function collapseNavBar() {
  return {
    type: actionTypes.COLLAPSE_NAVBAR
  }
}

/**
 * Capture details about keystrokes that came from the side nav bar.
 * We need this information so that we can override the default focus
 * behavior, for screen reader/accessibility purposes.
 * @param {object} ev The onKeyDown event.  The keycode information is extracted from this.
 * @param {object} navDetail The details of the side nav bar item that the keystroke applies to.
 * See the definition of NavDetail in the layout reducer for more details.
 */
export function setNavFromKey(ev, navDetail) {
  return {
    type: actionTypes.SET_NAV_FROM_KEY,
    navdetail: navDetail,
    keycode: ev.keyCode || ev.which
  }
}

/**
 * Null out the keystroke information from the nav side bar.
 * This includes the key code and the details of the nav side bar item that the recorded keystroke pertains to.
 */
export function unsetNavFromKey() {
  return {
    type: actionTypes.UNSET_NAV_FROM_KEY
  }
}

/**
 * Capture details about keystrokes that came from the dashboard tab set.
 * We need this information so that we can override the default focus
 * behavior, for screen reader/accessibility purposes.
 * @param {object} ev The onKeyDown event.  The keycode information is extracted from this.
 * @param {string} tabname The name of the tab that the keystroke applies to.
 */
export function setTabFromKey(ev, tabname) {
  return {
    type: actionTypes.SET_TAB_FROM_KEY,
    tabname: tabname,
    keycode: ev.keyCode || ev.which
  }
}

/**
 * Null out the keystroke information from the dashboard tab set.
 * This includes the key code and the details of the nav side bar item that the recorded keystroke pertains to.
 */
export function unsetTabFromKey() {
  return {
    type: actionTypes.UNSET_TAB_FROM_KEY
  }
}
